import CardMedia from "@mui/material/CardMedia";

export default function Image({ val }) {
  return (
    <CardMedia sx={{ height: 200 }} component='img' image={val} title="image of the product" />
  );
}
